import styled from 'styled-components'
import themeGet from '@styled-system/theme-get'

export const GridContainer = styled.div`
  position: relative;
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 32px 0;
  width: 100%;
  max-width: 1200px;

  > div:nth-child(3n + 1) {
    grid-row: 2 / 4;
  }

  > div:nth-child(3n + 2) {
    grid-row: 1 / 3;
  }

  > div:nth-child(2),
  > div:nth-child(3) {
    grid-column: 2 / 3;
  }

  > div {
    position: relative;
    z-index: 2;
  }

  > svg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    pointer-events: none;
    z-index: 1;
    stroke: ${themeGet('colors.pictonBlue')};
    fill: ${themeGet('colors.dollarBill')};
  }
`
